function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4762 12.9762C19.4762 14.6429 18.119 16 16.4524 16H0V4.02381C0 2.35714 1.35714 1 3.02381 1H19.4762V12.9762Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1191 9.9047H15.3691C15.4049 9.9047 15.4882 9.89279 15.5239 9.89279C15.762 9.84517 15.9644 9.63089 15.9644 9.33327C15.9644 9.04755 15.762 8.83327 15.5239 8.77375C15.4882 8.76184 15.4168 8.76184 15.3691 8.76184H14.1191V9.9047Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2257 2.01257C14.0352 2.01257 13.059 2.97686 13.059 4.17924V6.42924H16.1185C16.19 6.42924 16.2733 6.42924 16.3328 6.44114C17.0233 6.47686 17.5352 6.834 17.5352 7.45305C17.5352 7.94114 17.19 8.35781 16.5471 8.44114V8.46495C17.2495 8.51257 17.7852 8.90543 17.7852 9.51257C17.7852 10.1673 17.19 10.5959 16.4043 10.5959H13.0471V15.0007H16.2257C17.4162 15.0007 18.3924 14.0364 18.3924 12.834V2.01257H15.2257Z",
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8096 7.59559C15.8096 7.30987 15.6072 7.1194 15.3691 7.08368C15.3453 7.08368 15.2858 7.07178 15.2501 7.07178H14.1191V8.1194H15.2501C15.2858 8.1194 15.3572 8.1194 15.3691 8.10749C15.6072 8.07178 15.8096 7.8813 15.8096 7.59559Z",
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.25059 2.01257C2.06012 2.01257 1.08393 2.97686 1.08393 4.17924V9.52448C1.69107 9.8221 2.32202 10.0126 2.95297 10.0126C3.70297 10.0126 4.10774 9.56019 4.10774 8.94114V6.41733H5.96488V8.92924C5.96488 9.90543 5.35774 10.703 3.29821 10.703C2.04821 10.703 1.07202 10.4292 1.07202 10.4292V14.9888H4.25059C5.44107 14.9888 6.41726 14.0245 6.41726 12.8221V2.01257H3.25059Z",
  fill: "url(#paint3_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.2382 2.01257C8.04772 2.01257 7.07153 2.97686 7.07153 4.17924V7.01257C7.61915 6.54829 8.57153 6.25067 10.1072 6.3221C10.9287 6.35781 11.8096 6.584 11.8096 6.584V7.50067C11.3692 7.27448 10.8453 7.0721 10.1668 7.02448C9.00011 6.94114 8.29772 7.51257 8.29772 8.51257C8.29772 9.52448 9.00011 10.0959 10.1668 10.0007C10.8453 9.95305 11.3692 9.73876 11.8096 9.52448V10.4411C11.8096 10.4411 10.9406 10.6673 10.1072 10.703C8.57153 10.7745 7.61915 10.4769 7.07153 10.0126V15.0126H10.2501C11.4406 15.0126 12.4168 14.0483 12.4168 12.8459V2.01257H9.2382Z",
  fill: "url(#paint4_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 13.0576,
  y1: 9.33469,
  x2: 18.4073,
  y2: 9.33469,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2285,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7433,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 13.0569,
  y1: 8.50142,
  x2: 18.407,
  y2: 8.50142,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2285,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7433,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 13.0575,
  y1: 7.5941,
  x2: 18.4074,
  y2: 7.5941,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2285,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7433,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 1.08141,
  y1: 8.50142,
  x2: 6.51391,
  y2: 8.50142,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1F286F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4751,
  stopColor: "#004E94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8261,
  stopColor: "#0066B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006FBC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 7.04075,
  y1: 8.50142,
  x2: 12.317,
  y2: 8.50142,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C2C2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1735,
  stopColor: "#882730"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5731,
  stopColor: "#BE1833"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8585,
  stopColor: "#DC0436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E60039"
})));

var SvgJcb = function SvgJcb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJcb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jcb.66b2b169.svg";
export { ForwardRef as ReactComponent };